import { createCarousel, CarouselConfig } from "utils/carousel"
import "./index.scss"

require.context("./static", true, /\.jpg|svg$/)

// Component-specific configuration
const config: CarouselConfig = {
  carouselSelector: ".carousel-nearby-mountains__carousel",
  slideSelector: ".carousel-nearby-mountains__carousel__slide",
  slideGap: 20,
  cssClass: "carousel-nearby-mountains",
}

// Export the configured carousel instance
export const CarouselNearbyMountains = createCarousel(config)
